<template lang='pug'>
    div
        div.fullwidth(v-if="$route.params.lang == 'en'")
    
            div.title-container
                h1.product-title UHF Drain Valve Sensor Accessories
                //- h2.notopmargin BSS offers a range of sensors suitable for measurements of partial discharges in transformers in the ultra-high frequency range, for installation into new transformers or for retrofits.
    
            router-link.section(to='/en/products/pdaccessories/sensorcase')
                .column-container
                    .column
                        .producttitle Sensor Case
                        .subtitle Hard-carry-case for drain valve UHF sensors
                        ul
                            li Protection for UHF Sensors
                            li Various configurations possible

                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/SensorCase.webp')
                            img( src='@/assets/photos/for_product_overview/SensorCase.png', width="60%", alt='Sensor Case for UHF Sensors', title='Sensor Case for UHF Sensors')
    
            router-link.section(to='/en/products/pdaccessories/flangeadapters')
                .column-container
                    .column
                        .producttitle Flange Adapters
                        .subtitle Adapters for drain valves with higher diameter
                        ul
                            li Adapters for drain valve UHF sensors
                            li Various adapters available
                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/FlangeAdapter.webp')
                            img( src='@/assets/photos/for_product_overview/FlangeAdapter.png', width="60%", alt='Flange Adapter for higher diameters', title='Flange Adapter for higher diameters')
    
    
        div.fullwidth(v-if="$route.params.lang == 'de'")
    
            div.title-container
                h1.product-title UHF-Schiebesensor-Zubehör
                //- h2.notopmargin BSS offers a range of sensors suitable for measurements of partial discharges in transformers in the ultra-high frequency range, for installation into new transformers or for retrofits.
    
            router-link.section(to='/de/products/pdaccessories/sensorcase')
                .column-container
                    .column
                        .producttitle Sensorkoffer
                        .subtitle Tragekoffer für UHF-Sensoren
                        ul
                            li Schutzkoffer für UHF-Sensoren
                            li Verschiedene Konfigurationen möglich

                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/SensorCase.webp')
                            img( src='@/assets/photos/for_product_overview/SensorCase.png', width="100%", alt='Schutzkoffer für UHF-Sensoren', title='Schutzkoffer für UHF-Sensoren')
    
            router-link.section(to='/en/products/pdaccessories/flangeadapters')
                .column-container
                    .column
                        .producttitle Flanschadapter
                        .subtitle Adaptierungen für Ölschieber mit größerem Durchmesser
                        ul
                            li Adapter für Schiebesensoren
                            li Verschiedene Typen verfügbar
                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/FlangeAdapter.webp')
                            img( src='@/assets/photos/FlangeAdapter.png', width="60%", alt='Flansch-Adapter für Schiebesensoren', title='Flansch-Adapter für Schiebesensoren')
        
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | UHF-Sensor-Zubehör",
            description: "UHF-Schiebesensor-Zubehör",
        },
        en: {
            title: "BSS | UHF Sensors Accessories",
            description: "UHF Drain Valve Sensor Accessories",
        },
    },
    name: "SelectorLinks",
    props: {},
    data: function () {
        return {};
    },
};
</script>

<style scoped lang='sass'>
@import '@/assets/sass/product_overview.sass'
</style>